export const ORG_NOTES_FIELD_NAME = 'orgNotes';

export const ORG_NOTES_PLACEHOLDER = `Job Scope:

Most used rooms:

Any items NOT okay to reboot?`;

export type SiteDocumentationAccordionSectionKey =
  | 'siteOverview'
  | 'files'
  | 'systemInfrastructure'
  | 'subSystems';

export const SITE_DOCUMENTATION_ACCORDION_KEYS: SiteDocumentationAccordionSectionKey[] = [
  'siteOverview',
  'files',
  'systemInfrastructure',
  'subSystems',
];

export type SiteDocumentationAccordionState = Record<SiteDocumentationAccordionSectionKey, boolean>;

export const DEFAULT_ACCORDION_STATE: SiteDocumentationAccordionState = {
  siteOverview: true,
  files: true,
  systemInfrastructure: true,
  subSystems: true,
};

export const createDefaultAccordionState = (): SiteDocumentationAccordionState => ({
  ...DEFAULT_ACCORDION_STATE,
});

export const FILES_SECTION_MAX_WIDTH_PERCENT = 0.4;
export const FILES_SECTION_MAX_WIDTH = `${FILES_SECTION_MAX_WIDTH_PERCENT * 100}%` as const;

export const STACK_GAP = 16;
export const MAIN_SECTION_MIN_WIDTH = 300;
export const FIELD_COLUMN_MAX_WIDTH = 360;
export const FIELD_GRID_TWO_COLUMN_MIN_WIDTH = 600;

export const MIN_WIDTH_FOR_SPLIT_LAYOUT = Math.ceil(
  (MAIN_SECTION_MIN_WIDTH + STACK_GAP) / (1 - FILES_SECTION_MAX_WIDTH_PERCENT),
);
